export default function initVideoPlayer() {
  document.querySelectorAll('.video').forEach((el) => {
    const iframeEl = el.querySelector('iframe');
    iframeEl.setAttribute('tabindex', '-1');
    const thumb = el.querySelector('.btn-play');
    let play = false;
    var sourceSplit = [];
    var videoCode = '';
    var videoCodeStr = '';

    if (iframeEl.src.includes('youtube')) {
      if (iframeEl.src.includes('embed')) {
        sourceSplit = iframeEl.src.split('embed/');
        videoCodeStr = sourceSplit[1];

        if (videoCodeStr.includes('?')) {
          videoCode = videoCodeStr.slice(0, videoCodeStr.search(/\?/));
        } else if (videoCodeStr.includes('=')) {
          videoCode = videoCodeStr.slice(0, videoCodeStr.search('='));
        } else {
          videoCode = videoCodeStr;
        }

        iframeEl.src = `https://www.youtube.com/embed/${videoCode}?controls=1`;
      }

      if (iframeEl.src.includes('watch')) {
        sourceSplit = iframeEl.src.split('watch?v=');
        videoCodeStr = sourceSplit[1];

        if (videoCodeStr.includes('?')) {
          videoCode = videoCodeStr.slice(0, videoCodeStr.search(/\?/));
        } else if (videoCodeStr.includes('=')) {
          videoCode = videoCodeStr.slice(0, videoCodeStr.search('='));
        } else {
          videoCode = videoCodeStr;
        }

        iframeEl.src = `https://www.youtube.com/embed/${videoCode}?controls=1`;
      }

      if (iframeEl.src.includes('youtu.be')) {
        sourceSplit = iframeEl.src.split('youtu.be/');
        videoCodeStr = sourceSplit[1];

        if (videoCodeStr.includes('?')) {
          videoCode = videoCodeStr.slice(0, videoCodeStr.search(/\?/));
        } else if (videoCodeStr.includes('=')) {
          videoCode = videoCodeStr.slice(0, videoCodeStr.search('='));
        } else {
          videoCode = videoCodeStr;
        }

        iframeEl.src = `https://www.youtube.com/embed/${videoCode}?controls=1`;
      }

      if (iframeEl.src.includes('live')) {
        sourceSplit = iframeEl.src.split('live/');
        videoCodeStr = sourceSplit[1];

        if (videoCodeStr.includes('?')) {
          videoCode = videoCodeStr.slice(0, videoCodeStr.search(/\?/));
        } else if (videoCodeStr.includes('=')) {
          videoCode = videoCodeStr.slice(0, videoCodeStr.search('='));
        } else {
          videoCode = videoCodeStr;
        }

        iframeEl.src = `https://www.youtube.com/embed/${videoCode}?controls=1`;
      }
    }

    if (iframeEl.src.includes('vimeo')) {
      sourceSplit = iframeEl.src.split('/');
      videoCodeStr = sourceSplit[sourceSplit.length - 1];

      if (videoCodeStr.includes('?')) {
        videoCode = videoCodeStr.slice(0, videoCodeStr.search(/\?/));
      } else if (videoCodeStr.includes('=')) {
        videoCode = videoCodeStr.slice(0, videoCodeStr.search('='));
      } else {
        videoCode = videoCodeStr;
      }

      iframeEl.src = `https://player.vimeo.com/video/${videoCode}?controls=1`;
    }

    if (thumb) {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();

        iframeEl.removeAttribute('tabindex');

        if (play == false) {
          el.classList.add('video-playing');

          if (iframeEl.src.includes('?')) {
            iframeEl.src += '&autoplay=1&start=1';
            play = true;
          } else {
            iframeEl.src += '?&autoplay=1&start=1';
            play = true;
          }
        }
      });
    }
  });
}
